function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_0_3)"
}, React.createElement("path", {
  d: "M25 12.5a12.5 12.5 0 1 0-25 0 12.5 12.5 0 0 0 25 0Z",
  fill: "#F5F8FF"
}), React.createElement("path", {
  d: "m15.71 13.32-3.38 2.93a.76.76 0 0 1-1.14-.02.79.79 0 0 1 .01-1.03l3.16-2.7-3.16-2.7a.79.79 0 0 1-.01-1.03.76.76 0 0 1 1.14-.02l3.38 2.93s.29.34.29.82c0 .48-.29.82-.29.82Z",
  fill: "currentColor"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_0_3"
}, React.createElement("path", {
  fill: "#fff",
  transform: "rotate(-90 12.5 12.5)",
  d: "M0 0h25v25H0z"
})));

const SvgTabExpand = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgTabExpand, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tabExpand.c1a98673.svg";
export { ForwardRef as ReactComponent };